export const TIER_COLORS = {
    bronze: '#CD7F32',
    silver: '#C0C0C0',
    gold: '#FFD700',
    legendary: '#D4AF37',
};

const BADGE_LABELS = {
    bronze: 'BRONZE',
    silver: 'SILVER',
    gold: 'GOLD',
    legendary: 'LEGENDARY',
};

const NEXT_TIER = {
    bronze: 'silver',
    silver: 'gold',
    gold: 'legendary',
};

const CTA_BY_NEXT_TIER = {
    bronze: 'Verify & Earn',
    silver: 'Upgrade to Silver',
    gold: 'Upgrade to Gold',
    legendary: 'Go Legendary',
};

const ACTION_BY_NEXT_TIER = {
    bronze: 'verify',
    silver: 'upgrade_silver',
    gold: 'upgrade_gold',
    legendary: 'go_legendary',
};

export function getMediaProgressionState({ progress, coin, isGuest = false } = {}) {
    const currentTier = (progress?.tier ?? coin?.rarity ?? null)?.toLowerCase?.() ?? null;
    const nextTier = progress?.nextTier ?? progress?.next_tier ?? NEXT_TIER[currentTier] ?? 'bronze';
    const cooldownEndsAt = progress?.cooldownEndsAt ?? progress?.cooldown_ends_at ?? null;
    const isComplete = progress?.isComplete ?? progress?.is_complete ?? currentTier === 'legendary';
    const canUpgrade = progress?.canUpgrade ?? progress?.can_upgrade ?? (!isComplete && !cooldownEndsAt);

    if (isGuest || !currentTier) {
        return {
            currentTier: null,
            badgeLabel: null,
            ctaLabel: 'Verify & Earn',
            nextTier: 'bronze',
            isComplete: false,
            canUpgrade: true,
            cooldownEndsAt: null,
            action: 'verify',
        };
    }

    if (isComplete) {
        return {
            currentTier,
            badgeLabel: BADGE_LABELS[currentTier] ?? currentTier.toUpperCase(),
            ctaLabel: 'Legendary ✓',
            nextTier: null,
            isComplete: true,
            canUpgrade: false,
            cooldownEndsAt: null,
            action: 'view_coin',
        };
    }

    return {
        currentTier,
        badgeLabel: BADGE_LABELS[currentTier] ?? currentTier.toUpperCase(),
        ctaLabel: CTA_BY_NEXT_TIER[nextTier] ?? 'Verify & Earn',
        nextTier,
        isComplete: false,
        canUpgrade,
        cooldownEndsAt,
        action: ACTION_BY_NEXT_TIER[nextTier] ?? 'verify',
    };
}
